import { useCallback, useMemo } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";

import { useApi } from "shared/services/api/useApi";
import { useParams } from "react-router";

const useClientRateCards = () => {
    const { getDataAsync, postData, deleteData } = useApi();
    const queryClient = useQueryClient();
    const { clientId } = useParams();

    const getClientRateCardsApiCall = useCallback(async () => {
        const response = await getDataAsync("getRateCardsByClientId", {
            urlParams: [{ name: "$clientId", value: clientId }],
        });

        const result = response.status === 204
            ? null
            : response.json();

        return result;

    }, [getDataAsync, clientId]);

    const clientRateCards = useQuery(
        "clientRateCardsList",
        getClientRateCardsApiCall
    );

    const createClientRateCardApiCall = useCallback(
        ({ clientRateCardId, useAsDefault }) => {
            return postData("addRateCardByClientId", {
                urlParams: [
                    { name: "$clientId", value: clientId },
                    { name: "$rateCardId", value: clientRateCardId },
                    { name: "$useAsDefault", value: useAsDefault },
                ],
            });
        },
        [postData, clientId]
    );

    const deleteClientRateCardApiCall = useCallback(
        ({ clientRateCardId }) => {
            return deleteData("deleteRateCardByClientId", {
                urlParams: [
                    { name: "$clientId", value: clientId },
                    { name: "$rateCardId", value: clientRateCardId },
                ],
            });
        },
        [deleteData, clientId]
    );

    const mutationOptions = useMemo(() => {
        return {
            onSuccess: () => {
                queryClient.invalidateQueries("clientRateCardsList");
            },
        };
    }, [queryClient]);

    const createClientRateCard = useMutation(
        createClientRateCardApiCall,
        mutationOptions
    );
    const deleteClientRateCard = useMutation(
        deleteClientRateCardApiCall,
        mutationOptions
    );

    return useMemo(() => {
        return {
            clientRateCards,
            createClientRateCard,
            deleteClientRateCard,
        };
    }, [clientRateCards, createClientRateCard, deleteClientRateCard]);
};

export default useClientRateCards;
